export const defaultScalePlanimetria = 1;
export const handlerScale = 0.1;

export function handlerZoom(event, saveStateFunction, statusScroll, minScale = 0.5) {
  event.preventDefault();
  if (event.deltaY > 0) {
    const { horizontalScrollRef, verticalScrollRef } = statusScroll;
    saveStateFunction((zoomValue) => {
      if (!horizontalScrollRef && !verticalScrollRef) return zoomValue;
      const next = zoomValue - handlerScale;
      // Non scendere mai sotto minScale (fitScale del container)
      return next > minScale ? next : minScale;
    });
  } else {
    saveStateFunction((zoomValue) => {
      return zoomValue > 3 ? zoomValue : zoomValue + handlerScale;
    });
  }
}

let countClick = 0;
export function handlerMobileZoom(e, params) {
  e.preventDefault();
  const { saveStateFunction, refContainer, minScale = 0.5 } = params;
  if (countClick == 0) {
    // Primo tap: scala "normale" = max(1, minScale)
    saveStateFunction(Math.max(1, minScale));
    refContainer.current.scrollTop = refContainer.current.scrollTop;
    refContainer.current.scrollLeft = refContainer.current.scrollLeft;
  } else if (countClick == 1) {
    saveStateFunction(Math.max(1.5, minScale));
    refContainer.current.scrollTop = refContainer.current.scrollTop;
    refContainer.current.scrollLeft = refContainer.current.scrollLeft;
  } else {
    // Terzo tap: torna al fitScale (scala minima = immagine contenuta nel container)
    saveStateFunction(minScale);
    refContainer.current.scrollTop = refContainer.current.scrollTop;
    refContainer.current.scrollLeft = refContainer.current.scrollLeft;
    countClick = 0;
    return;
  }
  countClick++;
}

export function calcolaStato(scaleZoom) {
  let value = defaultScalePlanimetria - scaleZoom;
  value = Math.round(value * 10) / 10;
  return -(value);
}